// CUSTOM JavaScript
import './jquery-global.js';
import '../../node_modules/magnific-popup/dist/jquery.magnific-popup.js';
import '../../node_modules/readmore-js/readmore.js';
import '../../node_modules/bootstrap/dist/js/bootstrap.bundle';

$(document).ready(() => {
	// $('.popup-gallery').magnificPopup({
	// 	delegate: 'a',
	// 	type: 'image',
	// 	tLoading: 'Loading image #%curr%...',
	// 	mainClass: 'mfp-img-mobile',
	// 	fixedContentPos: true,
	// 	gallery: {
	// 		enabled: true,
	// 		navigateByImgClick: true,
	// 		preload: [0,1] // Will preload 0 - before current, and 1 after the current image
	// 	},
	// 	image: {
	// 		tError: '<a href="%url%">The image #%curr%</a> could not be loaded.',
	// 		// titleSrc(item) {
	// 		// 	return item.el.attr('title') + '<small>by Marsel Van Oosten</small>';
	// 		// }
	// 	}
	// });

	let startWindowScroll = 0;
	$('.popup-gallery').magnificPopup({
		delegate: 'a',
		type: 'image',
		tLoading: 'Loading image #%curr%...',
		mainClass: 'mfp-img-mobile',
		fixedContentPos: true,
		fixedBgPos: true,
		overflowY: 'auto',
		gallery: {
			enabled: true,
			navigateByImgClick: true,
			preload: [0,1] // Will preload 0 - before current, and 1 after the current image
		},
		image: {
			tError: '<a href="%url%">The image #%curr%</a> could not be loaded.',
			// titleSrc(item) {
			// 	return item.el.attr('title') + '<small>by Marsel Van Oosten</small>';
			// }
		},
		callbacks: {
			beforeOpen: function() {
				startWindowScroll = $(window).scrollTop();
			},
			open: function(){
				if ( $('.mfp-content').height() < $(window).height() ){
					$('body').on('touchmove', function (e) {
						e.preventDefault();
					});
				}
			},
			close: function() {
				$(window).scrollTop(startWindowScroll);
				$('body').off('touchmove');
			}
		}
	});

	$('.image-popup-vertical-fit').magnificPopup({
		type: 'image',
		closeOnContentClick: true,
		mainClass: 'mfp-img-mobile',
		image: {
			verticalFit: true
		}
	});

	$('.image-popup-fit-width').magnificPopup({
		type: 'image',
		closeOnContentClick: true,
		image: {
			verticalFit: false
		}
	});

	$('.image-popup-no-margins').magnificPopup({
		type: 'image',
		closeOnContentClick: true,
		closeBtnInside: false,
		fixedContentPos: true,
		mainClass: 'mfp-no-margins mfp-with-zoom', // Class to remove default margin from left and right side
		image: {
			verticalFit: true
		},
		zoom: {
			enabled: true,
			duration: 300 // Don't foget to change the duration also in CSS
		}
	});
});

// Check if the browser supports HTML5 history
const historySupport = `Boolean(window.history && history.pushState)`;

// Add an event listener for filter clicks
$(() => {
	$('body').on('click', 'main-filters .filters a', onFilterClick);
	$('body').on('click', '.mobile-filters a', onMobileFilterClick);
});

// Event handler for the filter click
function onMobileFilterClick(e) {
	const $mobileFilter = $(e.currentTarget);

	$('.mobile-filter').removeClass('active');
	$mobileFilter.addClass('active');
	let filterClass = $mobileFilter.attr('data-toggle');
	console.log(filterClass);
	$('.mobile-sub-filters .sub-filter').removeClass('d-block').addClass('d-none');
	$(`.${filterClass}`).removeClass('d-none').addClass('d-block');
}

// Event handler for the filter click
function onFilterClick(e) {
	e.preventDefault();
	const $filter = $(e.currentTarget);
	const filterCategory = $('.filter').attr('data-category');
	$('.filter').removeClass('active');
	$(`.${filterCategory}`).addClass('active');
	$filter.attr().addClass('active');
	const href = $filter.attr('href');
	if (historySupport) {
		// Update the browser's address bar
		history.pushState(null, null, href);
	}
	$.ajax($filter.attr('href'), {
		dataType: 'html',
		success(response) {
			refreshCategory(response);
		}
	});
}

function refreshCategory(html) {
	// Update the <title> tag
	// document.title = $(html).filter('.title').text();

	// Update the .projects DOM element with new HTML
	const $html = $('<div />').append(html);
	$('.category').html($html.find('.category').html());
}

$('.menu-toggle').on('click', function(e) {
	  e.stopPropagation();
	  e.preventDefault();
	  $('.menu-toggle, .mobile-menu').toggleClass('is-active');
	  $(".mobile-menu").slideToggle(300);
});

$(".toggle-password").click(function() {
	if ($(this).find('i').attr('data-icon') == 'eye-slash' ) {
	  $(this).find('i').attr('data-icon', 'eye');
	} else {
	  $(this).find('i').attr('data-icon', 'eye-slash');
	};
	const input = $($(this).attr('toggle'));
	if (input.attr('type') === 'password') {
		input.attr('type', 'text');
	} else {
		input.attr('type', 'password');
	}
});


$(".search-show-more").on('click',function (e) {
	var $searchGroup = $(this).closest('.search-group');
	var count = $searchGroup.data('count');
	$searchGroup.addClass('fuuu');
	$searchGroup.children('.search-group-item-link.hidden').slice(0,count).show().removeClass('hidden');
});

if ($('#slider').length) {

	var slider = $('#slider').carousel({
	  interval: 0
	});

	$(".slider-option").on('click',function() {
		$(this).addClass('active').siblings().removeClass('active');
		slider.carousel($(this).data('index'));
	});

	slider.on('slid.bs.carousel', function (e) {
		$(".slider-option[data-index='" + e.to + "']").addClass('active').siblings().removeClass('active');
	})

	slider.on('slide.bs.carousel', function (e) {
      var nextH = $(e.relatedTarget).outerHeight();
      $(this).find('.active.carousel-item').parent().animate({
          height: nextH
      }, 300);
  });
}

function fixSliderInnerHeight() {
	var nextH = $('#slider').find('.active.carousel-item').outerHeight();
	$('#slider').find('.carousel-inner').css({
			height: nextH
	});
}

// AJAX Registration

if ($('#purchaseRegistrationForm').length) {

	function displayErrors(errors) {
		$('#purchaseRegistrationForm .form-errors').html('');
		setTimeout(function() {
			for (var key in errors) {
				for (i = 0; i < errors[key].length; i++) {
					var html = '<li>'+errors[key][i]+'</li>';
					$('#purchaseRegistrationForm .form-errors').show().append(html);
				}
			}
			fixSliderInnerHeight();
		},300)
	}

	$('.form-swap').on('click',function() {
		if ($(this).data('form') == 'loginForm') {
			$('#purchaseRegistrationForm').hide();
			$('#purchaseLoginForm').show();
			$('#dynamicFormButton').text('Login');
		} else {
			$('#purchaseRegistrationForm').show();
			$('#purchaseLoginForm').hide();
			$('#dynamicFormButton').text('Create Account');
		}
		fixSliderInnerHeight();
	})

	function clearErrors() {
		$('#purchaseRegistrationForm .form-errors').html('');
	}

	function displayError(error) {
		$('#purchaseLoginForm .form-errors').html('');
		setTimeout(function() {
			var html = '<li>'+error+'</li>';
			$('#purchaseLoginForm .form-errors').show().append(html);
			fixSliderInnerHeight();
		},500);
	}

	function displayLoading(isLoading) {
		if (isLoading) {
			$('#formLoading').fadeIn();
		} else {
			$('#formLoading').fadeOut();
		}
	}

	function displaySuccess(isSuccess) {
		if (isSuccess) {
			$('#formSuccess').fadeIn();
		} else {
			$('#formSuccess').fadeOut();
		}
	}

	function unlockPurchase() {
		setTimeout(function() {
			$('#slider').carousel(1);
			$('#purchaseLocked').fadeOut();
		},500);
	}

	function updateCSRF(csrfValue) {
		let csrfFields = document.getElementsByName("CRAFT_CSRF_TOKEN");
		csrfFields.forEach((field) => {
			field.value = csrfValue;
		});
	}

	$('#purchaseRegistrationForm').submit(function(e) {
		e.preventDefault();
		clearErrors();
        var pw = $('#purchaseRegistrationForm #password').val();
		var firstName = $('#purchaseRegistrationForm input[name="firstName"]').val();
		var lastName = $('#purchaseRegistrationForm input[name="lastName"]').val();
		var email = $('#purchaseRegistrationForm input[name="email"]').val();

		var pw_error = '';
		var csrfToken = window.csrfTokenValue;
		// Validate the passwrod meets Craft's rules
		if (pw.length < 6) {
				pw_error = "Password length must be 6 or more characters";
		}
		if (pw_error) {
				alert(pw_error);
		}
		// Log the registration details for later retrieval
		else {
				displayLoading(true);
				$.ajax({
						method: 'POST',
						url: '/actions/users/save-user',
						dataType: "json",
						data: {
							CRAFT_CSRF_TOKEN: csrfToken,
							password: pw,
							firstName: firstName,
							email: email,
							lastName: lastName,
						},
						complete: function(response,data) {
							//console.log(response.responseJSON);
							if (response.responseJSON.errors) {
								displayErrors(response.responseJSON.errors);
							}

							if (Object.keys(response.responseJSON.user).length !== 0) {
								displaySuccess(true);
								unlockPurchase();
							}
							displayLoading(false);
						}
				});
		}
	})

	$('#purchaseLoginForm').submit(function(e) {
		e.preventDefault();
		displayLoading(true);
		clearErrors();
		var pw = $('#purchaseLoginForm input[type="password"]').val();
		var loginName = $('#purchaseLoginForm input[name="loginName"]').val();
		var csrfToken = window.csrfTokenValue;
		var pw_error = '';

		$.ajax({
				method: 'POST',
				url: '/actions/extender/user/login',
				dataType: "json",
				data: {
					CRAFT_CSRF_TOKEN: csrfToken,
					password: pw,
					loginName: loginName,
				},
				complete: function(response,data) {
					console.log(response.responseJSON);
					if (response.responseJSON.error) {
						displayError(response.responseJSON.error);
					}
					if (response.responseJSON.success == true) {
						displaySuccess(true);
						unlockPurchase();
						updateCSRF(response.responseJSON.csrfTokenValue);
					}
					displayLoading(false);
				}
		});
	})
}

//READMORE
$('#read-more').readmore({
	collapsedHeight: 125
});
$('#read-more-tickets').readmore({
	collapsedHeight: 125
});
$('#read-more-shows').readmore({
	collapsedHeight: 115
});

$('#read-more-lottery').readmore({
	collapsedHeight: 60
});

$(document).ready(() => {

	if ($('span.close')[0]) {
		$('span.close').each((index, e) => {
			let announcement = $(e).parent();
			let closeButton = $(e);
			announcement.hide();

			if (localStorage.getItem(closeButton.attr('id'))) {
				let storageDate = Date.parse(localStorage.getItem(closeButton.attr('id')));
				let now = new Date();
				let timeWindow = now.setHours(now.getHours() - 72);

				if (storageDate < timeWindow) {
					localStorage.removeItem(closeButton.attr('id'));
					announcement.show();
				}

			} else {
				announcement.show();
			}
		});

		$('span.close').on('click', (e) => {
			$(e.currentTarget)
				.parent()
				.hide();
			localStorage
				.setItem(
					$(e.currentTarget).attr('id'), new Date()
				);
		});

	}
});
